import classNames from 'classnames';
import React from 'react';

interface IBtnProps {
  color?: 'primary' | 'success' | 'danger' | 'custom';
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'custom';
  clear?: boolean;
  outline?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  onClick?: (e?: any) => void;
}

const Btn: React.FC<React.PropsWithChildren<IBtnProps>> = ({
  children,
  color = 'primary',
  className,
  size = 'md',
  clear,
  outline,
  hidden,
  onClick,
  disabled,
}) => {
  return (
    <button
      disabled={disabled}
      className={classNames(
        'items-center justify-center rounded-full font-roboto font-semibold',
        className,
        {
          // 'inline-flex': ['block', 'flex'].className?.includes('block'),
          'bg-primary text-white lg:hover:bg-rose-600 active:bg-rose-600':
            color === 'primary' && !clear,
          'bg-transparent': clear,
          'text-primary': color === 'primary' && clear,
          'text-success': color === 'success' && clear,
          'text-danger': color === 'danger' && clear,
          border: outline,
          'border-primary': outline && color === 'primary',
          'border-success': outline && color === 'success',
          'py-3.5 px-7 leading-[1.15em]': size === 'md',
          'py-2.5 px-3.5 text-xs leading-[1.5em]': size === 'sm',
          'grayscale opacity-30': disabled,
        }
      )}
      onClick={onClick}
      hidden={hidden}
    >
      {children}
    </button>
  );
};
export default Btn;
